var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 120,
    height: 100,
    rx: 8,
    fill: "#3B82F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 60,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 82,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 104,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 126,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 60,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 82,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 104,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 126,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#0F172A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 35,
    height: 30,
    rx: 3,
    fill: "#0F172A",
    opacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 60,
    width: 35,
    height: 30,
    rx: 3,
    fill: "#0F172A",
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 25,
    fill: "#60A5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 105 L93 125 L110 115 Z",
    fill: "#FFFFFF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 130,
    y2: 100,
    stroke: "#1E293B",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bd2d43b329c1c82b648dd39e7de3eed.svg";
export { ForwardRef as ReactComponent };